import React from 'react'

const DEFAULT_WIDTH = 24
const DEFAULT_HEIGHT = 24

const ShieldIcon = ({ width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT }: { width?: number; height?: number }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.25 14.5607L17.0303 8.78034L15.9697 7.71968L11.25 12.4394L8.78034 9.96968L7.71968 11.0303L11.25 14.5607Z'
        fill='#434343'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M21 2.25001L3 2.25V13.0625C3 14.8119 3.87134 16.4463 5.32377 17.4214L12 21.9033L18.6762 17.4214C20.1287 16.4463 21 14.8119 21 13.0625V2.25001ZM4.5 13.0625V3.75L19.5 3.75001V13.0625C19.5 14.3121 18.8776 15.4795 17.8402 16.176L12 20.0967L6.15983 16.176C5.12239 15.4795 4.5 14.3121 4.5 13.0625Z'
        fill='#434343'
      />
    </svg>
  )
}

export default ShieldIcon
